import { render, staticRenderFns } from "./Waiver.vue?vue&type=template&id=076ca657&scoped=true&lang=pug"
import script from "./Waiver.vue?vue&type=script&lang=js"
export * from "./Waiver.vue?vue&type=script&lang=js"
import style0 from "./Waiver.vue?vue&type=style&index=0&id=076ca657&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076ca657",
  null
  
)

export default component.exports